/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Badge_Read_OnlyInputs */



/**
* | output |
* | --- |
* | "Read-only" |
*
* @param {Integrations_Apis_Badge_Read_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_badge_read_only = /** @type {((inputs?: Integrations_Apis_Badge_Read_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Badge_Read_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur lesen")
	return /** @type {LocalizedString} */ ("Read-only")
});